import { render, staticRenderFns } from "./TheEmployeeInfoScreen.vue?vue&type=template&id=04f7ee4a&"
import script from "./TheEmployeeInfoScreen.vue?vue&type=script&lang=js&"
export * from "./TheEmployeeInfoScreen.vue?vue&type=script&lang=js&"
import style0 from "./TheEmployeeInfoScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports